import React, { useState, useEffect } from "react";
import styles from "./Sidebar.module.css";
import { NavLink } from "react-router-dom";
import {
  AccountBalance,
  Assessment,
  Person,
  TrendingUp,
} from "@mui/icons-material";
import logoWhiteTransparent from "/logo-white-tranparent.png";

interface SidebarProps {
  isOpen: boolean;
  onClose?: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const menuItems = [
    {
      text: "Finanças",
      path: "/finances",
      icon: <AccountBalance />,
      description: "Gerencie suas transações",
    },
    {
      text: "Relatórios",
      path: "/relatorios",
      icon: <Assessment />,
      description: "Visualize seus dados",
    },
    {
      text: 'Perfil',
      path: '/profile',
      icon: <Person />,
      description: 'Seus dados pessoais'
    }
  ];

  const handleItemClick = () => {
    // Fecha o sidebar em dispositivos móveis quando um item é clicado
    if (isMobile && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay para mobile */}
      {isOpen && isMobile && (
        <div className={styles.overlay} onClick={onClose} aria-hidden="true" />
      )}

      <aside
        className={`${styles.sidebar} ${!isOpen ? styles.sidebarClosed : ""}`}
      >
        <div className={styles.menuHeader}>
          <div className={styles.brandContainer}>
            <img style={{ width: "5rem", height: "auto" }} src={logoWhiteTransparent} alt="Logo Reactor Finances" />
          </div>
        </div>

        <nav>
          <ul className={styles.navList}>
            {menuItems.map((item) => (
              <li key={item.text}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    isActive
                      ? `${styles.navItem} ${styles.activeItem}`
                      : styles.navItem
                  }
                  onClick={handleItemClick}
                  title={item.description}
                >
                  <span className={styles.navIcon}>{item.icon}</span>
                  <div className={styles.navContent}>
                    <span className={styles.navText}>{item.text}</span>
                    <span className={styles.navDescription}>
                      {item.description}
                    </span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.footerContent}>
            <span className={styles.footerText}>v1.1.0</span>
          </div>
        </div>
      </aside>
    </>
  );
}
